"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentState = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: '17px',
  textTransform: 'uppercase'
}));
const StyledSpanLabel = (0, _mui.styled)('span')(({
  theme
}) => ({
  padding: '2px 15px',
  borderRadius: '5px',
  color: theme.palette.primary.contrastText
}));
const DocumentState = props => {
  const {
    state,
    reason
  } = props;
  const theme = (0, _mui.useTheme)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const getLocalization = approvalState => {
    switch (approvalState) {
      case 'Approved':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.stateApproved,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.stateApproved
        });
      case 'Pending':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.statePending,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.statePending
        });
      case 'Rejected':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.stateRejected,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.stateRejected
        });
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.stateUnknown,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.stateUnknown
        });
    }
  };
  const getStateColor = approvalState => {
    switch (approvalState) {
      case 'Approved':
        return theme.palette.secondary.main;
      case 'Pending':
        return theme.palette.warning.main;
      default:
        return 'transparent';
    }
  };
  const stateElement = /*#__PURE__*/(0, _jsxRuntime.jsx)(RootContainer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpanLabel, {
      style: {
        background: getStateColor(state)
      },
      children: getLocalization(state)
    })
  });
  if (reason) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      ...getTestIdProps('reason-tooltip'),
      title: reason,
      children: stateElement
    });
  }
  return stateElement;
};
exports.DocumentState = DocumentState;